exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1Xs7q{margin:0;padding:0;background:transparent;border:none}._1Xs7q ._14am_{height:24px;width:24px;cursor:pointer}._1Xs7q ._14am_.e1-GD{filter:invert(100%)}\n", ""]);

// Exports
exports.locals = {
	"close-button": "_1Xs7q",
	"closeButton": "_1Xs7q",
	"closeButtonImage": "_14am_",
	"dark": "e1-GD"
};